import {
  postFindByCondition,
  postNew,
  getById,
  putById,
  deleteById,
} from "./api/insurancedata";

import { getExport } from "./api/export";

import { downloadFile, openFile } from "@/utils/files";

class InsuranceDataService {
  async get(id) {
    return await getById(id);
  }

  async create(data) {
    return await postNew(data);
  }

  async update(id, data) {
    return await putById(id, data);
  }

  async delete(id) {
    return await deleteById(id);
  }

  getQueryOptions(
    holderName,
    salesmanName,
    insurance_number,
    renewDate,
    insured_dateS,
    insured_dateE
  ) {
    var query_options = [];
    if (
      holderName == "" &&
      salesmanName == "" &&
      insurance_number == "" &&
      renewDate == "" &&
      insured_dateS == "" &&
      insured_dateE == ""
    ) {
      return query_options;
    } else {
      if (holderName != "") {
        query_options.push({
          queryField: "holder",
          queryType: "like",
          queryData: holderName + "%",
        });
      }
      if (salesmanName != "") {
        query_options.push({
          queryField: "salesman",
          queryType: "like",
          queryData: salesmanName + "%",
        });
      }

      if (insurance_number != "") {
        query_options.push({
          queryField: "insurance_number",
          queryType: "like",
          queryData: insurance_number + "%",
        });
      }

      if (renewDate != "") {
        query_options.push({
          queryField: "renew",
          queryType: ">=",
          queryData: renewDate,
        });
      }

      if (insured_dateS != "") {
        query_options.push({
          queryField: "insured_date",
          queryType: ">=",
          queryData: insured_dateS,
        });
      }

      if (insured_dateE != "") {
        query_options.push({
          queryField: "insured_date",
          queryType: "<=",
          queryData: insured_dateE,
        });
      }
      return query_options;
    }
  }
  async findByCondition(
    holderName,
    salesmanName,
    insurance_number,
    renewDate,
    insured_dateS,
    insured_dateE,
    page,
    itemsPerPage
  ) {
    var data = {};
    var options = this.getQueryOptions(
      holderName,
      salesmanName,
      insurance_number,
      renewDate,
      insured_dateS,
      insured_dateE
    );

    if (
      holderName == "" &&
      salesmanName == "" &&
      insurance_number == "" &&
      renewDate == "" &&
      insured_dateS == "" &&
      insured_dateE == ""
    ) {
      data = {
        query_data: {
          type: "all",
          query_options: [],
          pagination: {
            itemsPerPage: itemsPerPage,
          },
        },
      };
    } else {
      data = {
        query_data: {
          type: "query",
          query_options: options,
        },
        pagination: {
          itemsPerPage: itemsPerPage,
        },
      };
    }

    return await postFindByCondition(page, data);
  }
  //呼叫匯出Excel API
  async exportExcel(
    type,
    holderName,
    salesmanName,
    insuranceNumber,
    renewDate,
    insured_dateS,
    insured_dateE,
    exportColumns
  ) {
    //var options = this.getQueryOptions(holderName, salesmanName, insurance_number, renewDate);
    //console.log(JSON.stringify(options),'options');
    console.log(type, "type");
    console.log(JSON.stringify(exportColumns), "exportColumns");
    console.log("insured_dateS=%s", insured_dateS);
    console.log("insured_dateE=%s", insured_dateE);
    try {
      //conditions=查詢條件；columns=匯出欄位
      const file = await getExport(`/export/insurancedata`, type, {
        holderName: holderName,
        salesmanName: salesmanName,
        insuranceNumber: insuranceNumber,
        renewDate: renewDate,
        insured_dateS: insured_dateS,
        insured_dateE: insured_dateE,
        columns: JSON.stringify(exportColumns),
      });
      const fileName = `保單資料`;
      const downloadFiles = {
        pdf: () => openFile(file, fileName, "pdf"),
        excel: () => downloadFile(file, fileName, "excel"),
      };
      downloadFiles[type]();
      return file;
    } catch (err) {
      return err;
    }
  }
  //呼叫匯出續期報表API
  async exportRenewReport(type, holderName, salesmanName, renewDate) {
    var params = {
      holderName: holderName,
      salesmanName: salesmanName,
      renewDate: renewDate,
    };
    try {
      //const file = await getRenewReport(type, params)
      const file = await getExport(`/export/renew`, type, params);
      const fileName = `續期名單`;
      const downloadFiles = {
        pdf: () => openFile(file, fileName, "pdf"),
        excel: () => downloadFile(file, fileName, "excel"),
      };
      downloadFiles[type]();
      return file;
    } catch (err) {
      return err;
    }
  }
}

export default new InsuranceDataService();
